interface Props {
  color?: string;
  className?: string;
}

export default function MenuHomeSvg(props: Props) {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_8818_110028)'>
        <path
          d='M1.5 10.5256L10.9993 3.49031C11.882 2.83656 13.118 2.83656 14.0007 3.49031L23.5 10.5256M5.16667 8.19795V18.6724C5.16667 19.9579 6.26108 21 7.61111 21H17.3889C18.7389 21 19.8333 19.9579 19.8333 18.6724V8.19795'
          stroke={props.color || '#737389'}
          strokeWidth='2'
          stroke-linecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_8818_110028'>
          <rect width='24' height='24' fill='white' transform='translate(0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
}
